"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var Avatar_1 = __importDefault(require("../Avatar"));
var react_redux_1 = require("react-redux");
var settingsSlice_1 = require("../../features/settings/settingsSlice");
var classnames_1 = __importDefault(require("classnames"));
var ImageUpload = function (_a) {
    var name = _a.name, img = _a.img, onImageChange = _a.onImageChange;
    var dispatch = react_redux_1.useDispatch();
    var settings = react_redux_1.useSelector(settingsSlice_1.settingsSelector);
    var t = react_i18next_1.useTranslation('common').t;
    var loader = react_redux_1.useSelector(settingsSlice_1.settingsAvatarLoadingSelector);
    var handlerChange = function (event) {
        if (event.target.files && event.target.files[0]) {
            var reader_1 = new FileReader();
            reader_1.onload = function () {
                if (reader_1.readyState === 2) {
                    onImageChange(reader_1.result);
                }
            };
            reader_1.readAsDataURL(event.target.files[0]);
        }
    };
    var handleDelete = function () {
        if (img) {
            dispatch(settingsSlice_1.deleteAvatar(settings.id));
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Avatar_1.default, { img: img, name: name, loader: loader }),
        react_1.default.createElement("label", { className: "file" },
            react_1.default.createElement("input", { type: "file", id: "file", className: "custom-file-input", onChange: handlerChange }),
            react_1.default.createElement("span", { className: "file-custom" }, t('IMAGE_UPLOAD'))),
        react_1.default.createElement("label", { htmlFor: "deleteAvatar" },
            react_1.default.createElement("span", { id: "deleteAvatar", onClick: handleDelete, className: classnames_1.default({
                    'delete-avatar file-custom': img,
                    'disabled-delete-avatar file-custom': !img,
                }) }, t('IMAGE_DELETE')))));
};
exports.default = ImageUpload;
